import { render, staticRenderFns } from "./branchallcountPartnerList.vue?vue&type=template&id=1a44c639&scoped=true&"
import script from "./branchallcountPartnerList.vue?vue&type=script&lang=js&"
export * from "./branchallcountPartnerList.vue?vue&type=script&lang=js&"
import style0 from "./branchallcountPartnerList.vue?vue&type=style&index=0&id=1a44c639&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a44c639",
  null
  
)

export default component.exports